export const WITHDRAW_BUFFER = 0.02;
